import { z } from 'zod';

/**
 * テスト設計（TestSpecDesign）対象テストスイート（ReleaseTest）選択画面の
 * URL search スキーマ。
 *
 * - freeText:        テストスイート名 / プロダクト名の部分一致検索
 * - page / pageSize: ページネーション
 */
export const releaseTestSpecTargetsSearchSchema = z.object({
  page: z.coerce.number().min(1).optional().default(1),
  pageSize: z.coerce.number().min(1).optional().default(50),
  freeText: z.string().optional()
});
export type ReleaseTestSpecTargetsSearch = z.infer<typeof releaseTestSpecTargetsSearchSchema>;